import { EmployerAgreementsService_employerAgreementServiceGetEntities } from '@festina/life-general-types/life/hooks/EmployerAgreementsService_employerAgreementServiceGetEntities'

export const useFetchEmployerAgreementEntitiesWithStatus =
  EmployerAgreementsService_employerAgreementServiceGetEntities.useSuspenseQuery
